import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { getChatListThunk, getChatMembersListThunk } from '../thunks/messageThunk';

const messageSlice = createSlice({
    name: 'message',
    initialState: {
        chatMembersList: "",
        chatList: "",
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getChatMembersListThunk.fulfilled, (state, action) => {
                state.chatMembersList = action.payload?.data;
            })
            .addCase(getChatListThunk.fulfilled, (state, action) => {
                state.chatList = action.payload?.data;
            })
    },
});

// export const { logout } = messageSlice.actions;

export default messageSlice.reducer;
